import Big from "big.js";

const ROUNDING_MODE = 2;
const ROUNDING_PLACES = 2;

/**
 * Setups up big.js instance
 *
 * @param {*} value
 */
const prepareBig = value => {
  const big = Big(value);
  big.DP = ROUNDING_PLACES;
  big.RM = ROUNDING_MODE;

  return big;
};

/**
 * Cart Calculation Library uses "Banked's Rounding" where it Rounds towards nearest neighbor.
 * If equidistant, rounds towards even neighbor.
 *
 * @param {*} value
 */
const bankRoundingUtil = value => {
  const bigValue = prepareBig(value);
  if (!bigValue || !bigValue.round) return value;
  return parseFloat(bigValue.round(ROUNDING_PLACES, ROUNDING_MODE));
};

export default bankRoundingUtil;
